<template>
  <section class="member-panel vip-overview">
    <header v-if="!data" class="member-panel-heading"><h1>VIP特权</h1><button class="reference-link" @click="navigate('/member/vip')">晋级彩金 ›</button></header>
    <PageState v-if="!isLoggedIn" title="登录后查看VIP特权" description="查询您的等级、进度和专属礼遇"><button class="primary" @click="openAuth('login')">登录</button></PageState>
    <PageState v-else-if="loading || error" :loading="loading" :error="error" @retry="load" />
    <template v-else-if="data">
      <template v-if="isDetails"><section class="vip-details-page"><header><button class="reference-link" @click="navigate('/mine/vip')">‹</button><h1>VIP详情</h1></header><div v-if="carouselLevels.length" class="vip-level-carousel" aria-label="VIP等级说明"><button class="vip-carousel-prev" aria-label="上一等级" @click="changeLevel(-1)">‹</button><article v-for="slide in levelSlides" :key="slide.position" :class="`vip-level-card position-${slide.position}`" :style="{backgroundImage:`url(${referenceAsset('vip-levels','card')})`}"><h2>{{ slide.level.levelName }}</h2><div class="vip-card-symbol"><img v-if="levelIcon(slide.level)" :src="levelIcon(slide.level)" alt="" /><span v-else>{{ slide.level.rankNo }}</span></div><div><p><b>{{ formatVipThreshold(slide.level.turnoverThreshold) }}</b><span>有效流水</span></p><p><b>{{ formatVipThreshold(slide.level.retentionTurnover) }}</b><span>保级流水</span></p></div></article><button class="vip-carousel-next" aria-label="下一等级" @click="changeLevel(1)">›</button></div><nav class="vip-carousel-dots" aria-label="选择VIP等级"><button v-for="level in carouselLevels" :key="level.levelId" :aria-label="level.levelName" :aria-current="level.levelId===selectedId?'true':undefined" :class="{active:level.levelId===selectedId}" @click="selectedId=level.levelId"></button></nav></section><section class="vip-details-table"><h2>VIP返水比例</h2><div class="record-table-scroll"><table class="record-table"><thead><tr><th>VIP等级</th><th v-for="level in data.levels || []" :key="level.levelId">{{ level.levelName }}</th></tr></thead><tbody><tr><td>返水比例</td><td v-for="level in data.levels || []" :key="level.levelId">{{ vipRebateRateText(level.rebateRules) }}</td></tr></tbody></table></div></section><section class="vip-details-table"><h2>VIP等级规则</h2><div class="record-table-scroll"><table class="record-table"><thead><tr><th>等级</th><th>累计存款门槛</th><th>有效流水门槛</th><th>保级流水</th><th>每日取款次数</th><th>单笔提款额度</th><th>每日取款总额度</th></tr></thead><tbody><tr v-for="level in data.levels || []" :key="level.levelId"><td>{{ level.levelName }}</td><td>{{ level.depositThreshold }}</td><td>{{ level.turnoverThreshold }}</td><td>{{ level.retentionTurnover }}</td><td>{{ level.dailyWithdrawalCount ?? '—' }}</td><td>{{ level.singleWithdrawalLimit ?? '—' }}</td><td>{{ level.dailyWithdrawalLimit ?? '—' }}</td></tr></tbody></table></div></section>
      <section class="vip-details-table">
        <h2>每周红包</h2>
        <div class="record-table-scroll"><table class="record-table" aria-label="每周红包金额与要求">
          <thead><tr><th>VIP等级</th><th>发放配置</th><th>近7日流水</th><th>有效期</th><th>红包金额</th></tr></thead>
          <tbody><tr v-for="level in weeklyLevels" :key="level.levelId"><td>{{ level.levelName }}</td><td>{{ level.weeklyDisplay.time }}</td><td>{{ level.weeklyDisplay.turnover }}</td><td>{{ level.weeklyDisplay.validity }}</td><td>{{ level.weeklyBonus ?? '—' }}</td></tr></tbody>
        </table></div>
      </section>
      </template><template v-else>
      <section class="vip-current"><div class="vip-medal" aria-hidden="true"><img v-if="currentLevelIcon" class="vip-medal-reference" :src="currentLevelIcon" alt="" /><template v-else><i></i><span>VIP<b>{{ String(data.levelName || '').replace(/\D/g,'') || '0' }}</b></span></template></div><div><h1>当前等级: {{ data.levelName || '--' }}</h1><p>流水：¥{{ data.currentTurnover }}</p></div><button class="primary" @click="navigate('/mine/vip/details')">查看VIP详情</button></section>
      <nav class="vip-level-tabs" aria-label="VIP等级"><button v-for="level in data.levels || []" :key="level.levelId" :class="{active:selectedId===level.levelId}" @click="selectedId=level.levelId">{{ level.levelName }}</button></nav>
      <section class="vip-next-level"><p>{{ data.nextLevelName?`距离下一等级：${data.nextLevelName}`:'当前已达到最高等级' }}</p><div><span>流水</span><div class="vip-progress" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" aria-label="晋级进度"><i :style="{width:`${progress}%`}"></i></div><span>晋级进度 {{ data.progressRate || '0' }}%</span></div></section>
      <template v-if="selected"><div class="member-section-heading"><h2>{{ selected.levelName }}尊享</h2><button class="reference-link" @click="navigate('/mine/vip/details')">查看VIP详情</button></div><div class="vip-benefits"><article v-for="(item,index) in benefits" :key="item.label"><span class="vip-benefit-icon"><img :src="referenceAsset('vip-benefits',index)" alt="" /></span><strong>{{ item.value ?? '--' }}</strong><span>{{ item.label }}</span></article></div></template>
      <div class="vip-entry-links"><button @click="navigate('/member/vip')"><b>晋级彩金</b><span>查看各等级规则及申请记录 ›</span></button><button @click="navigate('/member/gift')"><b>晋级豪礼</b><span>查看礼品与物流信息 ›</span></button><button @click="navigate('/mine/rebate')"><b>实时返水</b><span>查看当前返水及规则 ›</span></button></div>
      </template>
      <ErrorNotice v-if="ruleError" class="field-error" :message="ruleError"></ErrorNotice>
      <section v-if="ruleRows.length || privileges.length || privilegeError" class="vip-rule-list" aria-labelledby="vip-rule-title">
        <header class="vip-rule-heading">
          <h2 id="vip-rule-title">活动的一般条款与规则</h2>
        </header>
        <section v-if="privileges.length" class="vip-privilege-list" aria-label="VIP特权">
          <h3>VIP特权</h3>
          <dl>
            <div v-for="(item, index) in privileges" :key="item.code || index">
              <dt>{{ item.name }}</dt>
              <dd>{{ item.description }}</dd>
            </div>
          </dl>
        </section>
        <ErrorNotice v-if="privilegeError" class="field-error" :message="privilegeError"><button class="reference-link" @click="load">重试特权</button></ErrorNotice>
        <h3 v-if="privileges.length && ruleRows.length" class="vip-rules-subtitle">活动规则</h3>
        <ol v-if="ruleRows.length" class="vip-rule-body">
          <li v-for="(rule, index) in ruleRows" :key="`${rule.sortNo}-${index}`" class="vip-rule-item">
            <span class="vip-rule-index" aria-hidden="true">{{ index + 1 }}</span>
            <div class="help-rich-text vip-rule-content" v-html="sanitizeHelpContent(rule.content)"></div>
          </li>
        </ol>
      </section>
    </template>
  </section>
</template>
<script setup>
import ErrorNotice from '../feedback/ErrorNotice.vue'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { webApi } from '../../services/webApi'
import { useAppContext } from '../../composables/appContext'
import { readVipActivityRules } from '../../services/vipActivityRules.js'
import PageState from '../feedback/PageState.vue'
import { referenceAsset } from '../../config/referencePresentation.js'
import { vipRebateRateText, formatVipThreshold, readVipWeeklyDisplay } from '../../utils/vipPresentation.js'
const { currentPath, isLoggedIn, navigate, openAuth, sanitizeHelpContent } = useAppContext()
const data = ref(null), loading = ref(false), error = ref(''), selectedId = ref(0)
const privileges = ref([]), privilegeError = ref('')
const isDetails=computed(()=>currentPath.value==='/mine/vip/details')
const carouselLevels=computed(()=>{const all=data.value?.levels || [];const levels=all.filter(level=>Number(level.rankNo)>0);return levels.length?levels:all})
const levelSlides=computed(()=>{const levels=carouselLevels.value;if(!levels.length)return [];const index=Math.max(0,levels.findIndex(level=>level.levelId===selectedId.value));return [-1,0,1].map(position=>({position:position+1,level:levels[(index+position+levels.length)%levels.length]}))})
function changeLevel(direction){const levels=carouselLevels.value;if(!levels.length)return;const index=Math.max(0,levels.findIndex(level=>level.levelId===selectedId.value));selectedId.value=levels[(index+direction+levels.length)%levels.length].levelId}
watch([isDetails,()=>data.value?.levels],()=>{if(data.value)selectedId.value=isDetails.value?(carouselLevels.value[0]?.levelId || data.value.levelId):data.value.levelId})
let version = 0
const selected = computed(() => data.value?.levels?.find(level => level.levelId === selectedId.value))
function levelIcon(level){return level?.iconUrl || referenceAsset('vip-levels',Number(level?.rankNo))}
const currentLevelIcon=computed(()=>levelIcon(data.value?.levels?.find(level=>level.levelId===data.value?.levelId)) || referenceAsset('vip-levels',String(data.value?.levelName || '').replace(/\D/g,'')))
const progress = computed(() => Math.max(0, Math.min(100, Number(data.value?.progressRate) || 0)))
const benefits = computed(() => [
  { label: '每日提款次数', icon:'credit-card-outline', value: selected.value?.dailyWithdrawalCount },
  { label: '每日提款总额度', icon:'arrow-circle-down', value: selected.value?.dailyWithdrawalLimit },
  { label: '升级礼金', icon:'diamond', value: selected.value?.upgradeBonus },
  { label: '生日礼金', icon:'gift', value: selected.value?.birthdayBonus },
  { label: '每周红包', icon:'money', value: selected.value?.weeklyBonus },
])
const weeklyLevels = computed(() => (data.value?.levels || []).map(level => ({ ...level, weeklyDisplay: readVipWeeklyDisplay(level.weeklyBonusRule) })))
const ruleState = computed(() => { try { return { rows: readVipActivityRules(data.value?.rules), error: '' } } catch (e) { return { rows: [], error: e.message } } })
const ruleRows = computed(() => ruleState.value.rows)
const ruleError = computed(() => ruleState.value.error)
async function load() {
  const ticket = ++version
  if (!isLoggedIn.value) { data.value = null; privileges.value = []; privilegeError.value = ''; loading.value = false; return }
  loading.value = true; error.value = ''; privilegeError.value = ''
  try {
    const [detail, extras] = await Promise.allSettled([webApi.vipDetail(), isDetails.value ? webApi.vipPrivileges() : Promise.resolve([])])
    if (ticket !== version) return
    if (detail.status === 'rejected') throw detail.reason
    data.value = detail.value; selectedId.value = detail.value.levelId
    privileges.value = extras.status === 'fulfilled' ? extras.value || [] : []
    if (extras.status === 'rejected') privilegeError.value = extras.reason?.message || 'VIP特权加载失败'
  } catch (e) { if (ticket === version) { data.value = null; privileges.value = []; error.value = e.message || 'VIP信息加载失败' } }
  finally { if (ticket === version) loading.value = false }
}
watch([isLoggedIn, currentPath], load, { immediate: true })
onBeforeUnmount(() => { version++ })
</script>

<style scoped>
.vip-privilege-list { margin-top: 24px; }
.vip-privilege-list h3,
.vip-rules-subtitle { margin: 0; color: #303442; font-size: 15px; font-weight: 600; line-height: 24px; }
.vip-privilege-list dl { margin: 16px 0 26px; counter-reset: privilege; }
.vip-privilege-list dl > div {
  position: relative;
  min-width: 0;
  padding-left: 28px;
  color: #505970;
  font-size: 14px;
  line-height: 1.9;
  overflow-wrap: anywhere;
  counter-increment: privilege;
}
.vip-privilege-list dl > div + div { margin-top: 16px; }
.vip-privilege-list dl > div::before {
  content: counter(privilege);
  position: absolute;
  top: 4px;
  left: 0;
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  background: #159bff;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.vip-privilege-list dt { display: inline; font-weight: 500; }
.vip-privilege-list dt::after { content: '：'; }
.vip-privilege-list dd { display: inline; margin: 0; white-space: pre-line; }
.vip-rule-list {
  margin-top: 16px;
  padding: 24px 24px 28px;
  border-radius: 12px;
  background: #fff;
}
.vip-rule-heading h2 {
  margin: 0;
  color: #303442;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}
.vip-rule-body {
  margin: 0;
  padding: 16px 0 0;
  list-style: none;
}
.vip-rule-item {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  min-width: 0;
}
.vip-rule-item + .vip-rule-item {
  margin-top: 16px;
}
.vip-rule-index {
  display: grid;
  place-items: center;
  margin-top: 4px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  background: #159bff;
}
.vip-rule-content {
  min-width: 0;
  color: #505970;
  font-size: 14px;
  line-height: 1.9;
  overflow-x: auto;
  overflow-wrap: anywhere;
}
.vip-rule-content :deep(h1),
.vip-rule-content :deep(h2),
.vip-rule-content :deep(h3),
.vip-rule-content :deep(h4),
.vip-rule-content :deep(h5),
.vip-rule-content :deep(h6) {
  margin: 20px 0 10px;
  color: #424b60;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
}
.vip-rule-content :deep(p) {
  margin: 0 0 12px;
  color: inherit;
  line-height: inherit;
}
.vip-rule-content :deep(ul),
.vip-rule-content :deep(ol) {
  margin: 0 0 12px;
  padding-left: 22px;
}
.vip-rule-content :deep(li + li) {
  margin-top: 8px;
}
.vip-rule-content :deep(table) {
  width: 100%;
  margin: 12px 0;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
}
.vip-rule-content :deep(th),
.vip-rule-content :deep(td) {
  padding: 10px 14px;
  border: 0;
  text-align: center;
}
.vip-rule-content :deep(th) {
  color: #424b60;
  font-weight: 600;
  background: #eceff7;
}
.vip-rule-content :deep(tbody tr:nth-child(even)) { background: #f5f7fb; }
.vip-rule-content :deep(> :first-child) {
  margin-top: 0;
}
.vip-rule-content :deep(> :last-child) {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .vip-rule-list {
    padding: 18px 16px 20px;
  }
  .vip-rule-heading h2 {
    font-size: 16px;
    line-height: 24px;
  }
  .vip-privilege-list { margin-top: 20px; }
  .vip-privilege-list dl { margin-bottom: 22px; }
}
</style>
